<template>
    <svg
        :width="width"
        :height="height"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="color"
    >
        <mask id="mask-drag-handle" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
            <rect width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask-drag-handle)">
            <path d="M4.5 14.75V13.25H19.5V14.75H4.5ZM4.5 10.75V9.25H19.5V10.75H4.5Z" fill="currentColor" />
        </g>
    </svg>
 </template>

 <script>
 export default {
     name: 'drag-handle-icon',
     props: {
         width: { type: [String, Number], default: 24 },
         height: { type: [String, Number], default: 24 },
         color: { type: String, default: 'text-gray-400' },
     },
 };
 </script>


